export type Permission =
  | 'datafy.read.users'
  | 'datafy.write.config'
  | 'datafy.write.autoscaling'
  | 'datafy.write.autoscaling.rules'
  | 'datafy.write.volumes';

export type PermissionCheck = Permission | Permission[];

function matchOne(userPermissions: string[], required: Permission): boolean {
  return userPermissions.some((p) => {
    if (p.endsWith('.*')) {
      const prefix = p.slice(0, -1);
      return required.startsWith(prefix);
    }
    return p === required;
  });
}

export function hasPermission(
  userPermissions: string[],
  required: PermissionCheck,
  check: 'any' | 'all' = 'any'
): boolean {
  if (Array.isArray(required)) {
    if (check === 'all') {
      return required.every((r) => matchOne(userPermissions, r));
    }
    return required.some((r) => matchOne(userPermissions, r));
  }
  return matchOne(userPermissions, required);
}
